import { createSlice } from '@reduxjs/toolkit'
import {
  configurationGridLayout,
  gridLayoutContainerIdRelation,
  IsLoadConfigurationAction,
  IsSaveConfigurationAction,
  reactGridLayoutArray,
} from '../../Constants/Configuration'
import { decryptLocalStorageValue, encryptLocalStorageValue } from '../../Helpers/ConfigurationHelper'

export const gridLayoutSlice = createSlice({
  name: 'dynamicGrid',
  initialState: {
    gridLayout: reactGridLayoutArray,
    gridOnOneColumn: true,
  },
  reducers: {
    setStoredGridLayout: (state, action) => {
      state.gridLayout = action.payload
    },
    setGridColumn: (state, action) => {
      state.gridOnOneColumn = action.payload
    },
    updateLayoutFromObserver: (state, action) => {
      const anElementHeightChange = state.gridLayout.find(gridElement => {
        const container = gridLayoutContainerIdRelation.find(x => x.id === gridElement.i)?.container
        const gridElementChanged = action.payload.find(x => x.containerId === container)

        return gridElementChanged && gridElement.h !== gridElementChanged?.height
      })

      if (anElementHeightChange) {
        state.gridLayout = state.gridLayout.map(x => {
          const gridCopy = { ...x }
          const container = gridLayoutContainerIdRelation.find(x => x.id === gridCopy.i)?.container
          const gridElement = action.payload.find(x => x.containerId === container)

          if (gridElement) {
            gridCopy.h = gridElement.height
          }

          return gridCopy
        })
      }
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsLoadConfigurationAction, (state, action) => {
        const storedConfigurationGridLayout = decryptLocalStorageValue(
          action.payload.configurationName + configurationGridLayout,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.gridLayout = storedConfigurationGridLayout
          ? JSON.parse(storedConfigurationGridLayout)
          : reactGridLayoutArray

        state.gridOnOneColumn = state.gridLayout.every(grid => grid.w === 12)
      })
      .addMatcher(IsSaveConfigurationAction, (state, action) => {
        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationGridLayout,
          JSON.stringify(state.gridLayout),
          action.payload.user,
          action.payload.serverConfig,
        )
      })
  },
})

export const { setStoredGridLayout, updateLayoutFromObserver, setGridColumn } = gridLayoutSlice.actions

export default gridLayoutSlice.reducer
